import { createAction, props } from '@ngrx/store';
import { Goal, GoalCategory } from './goal.models';


export const loadGoalCategories = createAction(
  '[Goal] Load Goal Categories'
);

export const loadGoalCategoriesSuccess = createAction(
  '[Goal] Load Goal Categories Success',
  props<{goalCategories: GoalCategory[]}>()
);

export const loadGoalCategoriesFailure = createAction(
  '[Goal] Load Goal Categories Failure',
  props<{ error: string }>()
);


export const loadGoals = createAction('[Goal] Load Goals');

export const loadGoalsSuccess = createAction(
  '[Goal] Load Goals Success',
  props<{ goals: Goal[] }>()
);

export const loadGoalsFailure = createAction(
  '[Goal] Load Goals Failure',
  props<{ error: any }>()
);

export const clearGoals = createAction(
  '[Goal] Clear Goals'
);
